import { IBaseSettings } from '$/types'
import { getDetailsValueByKey } from 'common/utils/settingsUtils'

import { ICoordinates } from 'features/Map/interfaces/Maps'

export const getBaselineTitle = (name: string | undefined): string => {
  if (name) {
    return `${name} (Risk Baseline)`
  } else {
    return 'Risk Baseline'
  }
}

export const getDefaultCenterCoordinates = (
  mapCenterCoordinates: string
): number[] => {
  if (mapCenterCoordinates) {
    const coordinates: ICoordinates = JSON.parse(mapCenterCoordinates)

    return [coordinates.lon, coordinates.lat]
  } else {
    return [0, 0]
  }
}

export const getCenterlineUrl = (
  baseSettings: IBaseSettings[] | undefined
): string => {
  const centerlineUrl = getDetailsValueByKey(
    baseSettings,
    'MapSettings',
    'Centerline'
  )

  return `${import.meta.env.LH_TIMP_ARC_SERVER}${centerlineUrl}`
}

export const getStructureLayerUrl = (
  baseSettings: IBaseSettings[] | undefined
): string => {
  const structureLayerUrl = getDetailsValueByKey(
    baseSettings,
    'MapSettings',
    'StructureLayer'
  )

  return `${import.meta.env.LH_TIMP_ARC_SERVER}${structureLayerUrl}`
}

export const getWisTitle = (layerName: string | undefined): string => {
  if (layerName) {
    return `${layerName} (WIS Risk)`
  } else {
    return 'WIS'
  }
}

export const createBatches = <T>(items: T[], batchSize: number): T[][] => {
  if (batchSize <= 0) {
    throw new Error('Batch size must be greater than zero')
  }

  const batches: T[][] = []

  for (let index = 0; index < items.length; index += batchSize) {
    batches.push(items.slice(index, index + batchSize))
  }

  return batches
}
